import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getAllIntegrationNotificationSettings,
  getIntegrationNotificationSettingsById,
  upsertIntegrationNotificationSettings,
} from "controller/api";
import { ApiErrorType } from "shared";
import { sentryLogger } from "utilz";

export const useUpsertIntegrationNotificationSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: upsertIntegrationNotificationSettings,
    onSuccess: () => {
      queryClient.invalidateQueries(["integrationNotificationSettings"]);
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "integration",
        functionName: "upsertIntegrationNotificationSettings",
      });
    },
  });
};

export const useGetAllIntegrationNotificationSettings = () => {
  return useQuery({
    queryKey: ["integrationNotificationSettings"],
    queryFn: () => getAllIntegrationNotificationSettings(),
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "integration",
        functionName: "getAllIntegrationNotificationSettings",
      });
    },
  });
};

export const useGetIntegrationNotificationSettingsById = (
  sourceId?: string
) => {
  return useQuery({
    queryKey: ["integrationNotificationSettings", sourceId],
    queryFn: () => getIntegrationNotificationSettingsById(sourceId || ""),
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "integration",
        functionName: "getIntegrationNotificationSettingsById",
      });
    },
    enabled: sourceId ? true : false,
  });
};
